<fieldset
  [class.tab--container]="checkboxStyle() === 'tabs'"
  [formGroup]="parentForm()"
>
  <legend>
    {{ field().label }}
    @if (field().required) {
      <span class="overline" aria-required="true"> * </span>
    }
  </legend>

  <div
    [class.tabs__options-container]="checkboxStyle() === 'tabs'"
    [formArrayName]="field().key"
  >
    @for (option of field().options; track $index) {
      <label
        [for]="'option-' + $index"
        [class.tabs--label]="checkboxStyle() === 'tabs'"
        [class.disabled]="parentForm().controls[field().key].disabled || isDisabled()"
        [title]="option.value"
      >
        <input
          type="checkbox"
          [id]="'option-' + $index"
          [attr.name]="option.key"
          [formControlName]="$index"
          [checked]="getChecked($index)"
          (change)="updateValue($event)"
        />
        <span>{{ option.value }}</span>
      </label>
    }
  </div>

  <!-- Error messages -->
  @if (hasErrors) {
    <ul>
      @for (error of errorsList; track errorsList) {
        <li class="underlined-form-field-error caption error">
          {{ error }}
        </li>
      }
    </ul>
  }
</fieldset>
